import _ from 'lodash';
import { useState } from 'react';
import { ListGroup } from 'react-bootstrap';
import { AiFillFileText } from 'react-icons/ai';
import { fileAccept } from '../../commons/constants/public-form.constants';
import IconWrapper from '../IconWrapper';
import './style.scss';

interface PublicFileInputProps {
  register: any;
  questionId: string;
  disabled?: boolean;
  currentValue?: string;
  setValue?: any;
}

const PublicFileInput = ({
  register,
  questionId,
  currentValue,
  setValue,
  disabled = false
}: PublicFileInputProps) => {
  const [temporalFileList, setTemporalFileList] = useState<FileList | null>(null);

  const validateFile = (fileList: FileList | null) => {
    return fileList?.length !== 0 || 'Esta pregunta es obligatoria.';
  };

  const fileInputRegister = register(questionId, { validate: validateFile });

  const getFileLinks = (links: string) => {
    return (
      <ListGroup className="list-group-file mb-2">
        {links.split('|').map((link, idx) => (
          <ListGroup.Item key={link} className="d-flex align-items-center">
            <IconWrapper size={20}>
              <AiFillFileText />
            </IconWrapper>
            <a className="mx-2" href={link} target="_blank" rel="noreferrer">
              Archivo adjunto {idx + 1}
            </a>
          </ListGroup.Item>
        ))}
      </ListGroup>
    );
  };

  const onInputFileChange = (ev: Event) => {
    if (temporalFileList) {
      const target = ev.target as HTMLInputElement;

      const dt = new DataTransfer();

      _.forEach(temporalFileList, (file) => dt.items.add(file));
      _.forEach(target.files, (file) => dt.items.add(file));

      target.files = dt.files;
    }

    fileInputRegister.onChange(ev);

    const target = ev.target as HTMLInputElement;

    setTemporalFileList(target.files);
  };

  const handleFileDeleteClick = (idxFile: number, ev: any) => {
    ev.stopPropagation();
    const dt = new DataTransfer();

    _.forEach(temporalFileList, (file, idx) => {
      if (idx !== idxFile) {
        dt.items.add(file);
      }
    });

    setValue(questionId, dt.files);
    setTemporalFileList(dt.files);
  };

  return disabled ? (
    getFileLinks(currentValue!)
  ) : (
    <>
      <ListGroup className="list-group-file mb-2">
        {_.map(temporalFileList, (file: File, idx) => (
          <ListGroup.Item className="d-flex align-items-center justify-content-between" key={idx}>
            <div className="d-flex align-items-center">
              <IconWrapper size={20}>
                <AiFillFileText />
              </IconWrapper>
              <span className="mx-2 text-primary">{file.name}</span>
            </div>
            <div
              className="file-delete cursor-pointer"
              onClick={handleFileDeleteClick.bind(null, idx)}>
              <span>X</span>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
      <input
        {...fileInputRegister}
        id={questionId}
        className="form-input"
        type="file"
        multiple
        accept={fileAccept}
        disabled={disabled}
        onChange={onInputFileChange}
      />
      <label className="btn btn-primary btn-sm" htmlFor={questionId}>
        Subir archivos
      </label>
    </>
  );
};

export default PublicFileInput;
